._TemplateModal_14o1q_1 ._templateList_14o1q_1 {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin-top: 16px;
  height: 400px;
  overflow-y: auto;
  padding-right: 10px;
}